import { PayloadAction } from '@reduxjs/toolkit';

import { FontState } from 'editor/src/store/fonts/types';

const setFontUploadEnabledReducer = (state: FontState, action: PayloadAction<boolean>) => {
  state.fontUploadEnabled = action.payload;
};

export default setFontUploadEnabledReducer;
